<template>
    <div class="modal-form__shadow" >
        <div class="modal-form">

            <slot>
            </slot>
        </div>
    </div>
</template>
<script>
    export default{
    }
</script>
<style>
.modal-form__shadow{
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color:  #3D3D3D80;
    top: 0;
    left: 0;
    z-index: 4;
    display: flex;
    align-content: center;
    justify-content: center;
}
.modal-form{
    background-color: var(--white);
    width: 620px;
    height: 700px;
    margin: auto;
    position: relative;
}
    /* #3D3D3D80 */

</style>